import { apiClient } from '@/config/api';

export interface DashboardStats {
  projects: number;
  buildings: number;
  apartments: number;
  boxes: { total: number; online: number; offline: number };
  thermostats: { total: number; online: number; offline: number };
  heatingSetpoint: number | null;
}

export const dashboardService = {
  async getStats(projectId?: number): Promise<DashboardStats> {
    const params: Record<string, unknown> = {};
    if (typeof projectId === 'number' && Number.isFinite(projectId) && projectId > 0) {
      params.projectId = projectId;
    }

    const res = await apiClient.get<DashboardStats>('/dashboard/stats', { params });
    return res.data;
  },
};

